<template>
  <div class="col-12 col-md-10 col-lg-8" v-if="finishedLoading">
            <form>
                <!-- FORMULÁRIO EMPRÉSTIMO DE IMPACTO -->
                <div id="emprestimo-impactol">
                    <div class="text-center sub-title">
                        <p>{{firstName}}, preencha todas as informações abaixo Todos os campos são obrigatórios..</p>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 form">
                            <label for="nome">Nome completo</label>
                            <input type="text" class="form-control form-control-lg" id="nome" placeholder="Nome completo" v-model="name">
                        </div>
                        <div class="col-12 col-md-6 form">
                            <label for="">Email </label>
                            <input type="text" class="form-control form-control-lg" placeholder="E-mail" v-model="email" disabled>
                        </div>                
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 form">
                            <label for="">Telefone de contato</label>
                            <input type="text" class="form-control form-control-lg" placeholder="(00) 00000-0000" v-model="phone" v-mask="'phone'">
                        </div>
                        <div class="col-12 col-md-6 form">
                            <label for="">Para quem se destina o empréstimo</label>
                            <at-select filterable size="large" required placeholder="Selecione..." v-model="tipoPessoa">
                                <at-option v-for="(option, index) in tipo" :key="`temTipo${index}`" :value="option.value">{{option.value}}</at-option>
                            </at-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 form" v-if="tipoPessoa !== '' && tipoPessoa === 'pessoa juridica'">
                            <label for="">CNPJ</label>
                            <input type="text" class="form-control form-control-lg" placeholder="CNPJ" v-mask="'cnpj'" v-model="document" required="required">
                        </div>
                        <div class="col-12 col-md-6 form" v-if="tipoPessoa !== '' && tipoPessoa === 'pessoa fisica'">
                            <label for="">CPF</label>
                            <input type="text" class="form-control form-control-lg" placeholder="CPF" v-mask="'cpf'" v-model="document" required="required">
                        </div>
                        <div class="col-12 col-md-3 form">
                            <label for="">Possui restrição?</label>
                            <at-select filterable size="large" required placeholder="Selecione..." v-model="restricao">
                                <at-option v-for="(option, index) in temRestricao" :key="`temRestricaoOptions${index}`" :value="option.value">{{option.label}}</at-option>
                            </at-select>
                        </div>
                        <div class="col-12 col-md-3 form">
                            <label for="">Possuí garantia?</label>
                            <at-select filterable size="large" required placeholder="Selecione..." v-model="garantia">
                                <at-option v-for="(option, index) in temGarantia" :key="`temGarantiasOptions${index}`" :value="option.value">{{option.label}}</at-option>
                            </at-select>
                        </div>   
                    </div>

                    <div v-if="garantia == 'sim'" class="row">
                        <div class="col-12 form">
                            <label for="">Informe a garantia</label>
                            <at-select filterable size="large" required placeholder="Selecione..." v-model="garantiaDetalhe">
                                <at-option v-for="(garantia, index) in garantias" :key="`garantiasOptions${index}`" :value="garantia.value">{{garantia.value}}</at-option>
                            </at-select>
                        </div>
                    </div>

                    <div v-if="garantiaDetalhe === 'Outros' && garantia === 'sim'" class="row">
                        <div class="col-12 form">
                            <label for="">Informa o tipo de garantia</label>
                            <input type="text" class="form-control form-control-lg" placeholder="Informe a garantia" v-model="garantiaOutros" required>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 form">
                            <label for="">Faturamento da empresa nos últimos 12 meses</label>
                            <input type="text" class="form-control form-control-lg" placeholder="R$ 00.000,00" v-model="faturamento" v-mask="'money'">
                            <label v-if="redirectInvestment != 'social'">
                                <a v-if="redirectInvestment == 'impact'"
                                    @click="changeType('EMPIMP2')">
                                    Sua empresa não se enquadra no empréstimo social
                                    Clique aqui para acessar o emprestimo de impacto
                                </a>
                                <a v-if="redirectInvestment == 'collective'"
                                    @click="changeType('EMPCOL')">
                                    Sua empresa não se enquadra no empréstimo social
                                    Clique aqui para acessar o emprestimo coletivo
                                </a>
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-4 form">
                            <label for="">Valor solicitado</label>
                            <input type="text" class="form-control form-control-lg" placeholder="Ex.: R$ 7.000,00" v-model="value" v-mask="'money'">
                                                 
                        </div>
                        <div class="col-12 col-md-4 form">
                            <label for="">Prazo</label>
                            <at-select filterable size="large" required placeholder="Selecione..." v-model="prazo">
                                <at-option v-for="(prazo, index) in prazos" :key="`prazosOptions${index}`" :value="prazo.value">{{prazo.label}}</at-option>
                            </at-select>
                        </div> 
                        <div class="col-12 col-md-4 form">
                            <label for="">Motivo do empréstimo</label>
                            <at-select filterable size="large" required placeholder="Selecione..." v-model="motivo">
                                <at-option v-for="(motivo, index) in motivoEmp" :key="`motivoOptions${index}`" :value="motivo.value">{{motivo.value}}</at-option>
                            </at-select>
                        </div>             
                    </div>
                    <div v-if="motivo == 'Outros'"  class="row">
                        <div class="col-12 form">
                            <label for="">Finalidade</label>
                            <input type="text" class="form-control form-control-lg" placeholder="Informe o motivo" v-model="motivoDetalhe">
                        </div>              
                    </div>
                </div>
                <!-- FINAL FORMULÁRIO EMPRÉSTIMO IMPACTO -->

                <div class="row">
                    <div class="col-12">
                        <h5>Por último, precisamos que você:</h5>
                        <ul>
                            <li><img src="/static/assets/images/checked.svg" width="18"><span id="autorizacaoCPF_CNPJ"> Autorize o banco parceiro a consultar seu CPF/CNPJ.</span></li>
                            <li><img src="/static/assets/images/checked.svg" width="18"><span> Autorize o banco parceiro a compartilhar as suas informações com a IOUU.</span></li>
                            <li><img src="/static/assets/images/checked.svg" width="18"><span> Declare que as informações que forneceu são verdadeiras.</span></li>
                            <li id="autorizacaoPPE"><img src="/static/assets/images/checked.svg" width="18"><span> Confirme que não é Pessoa Exposta politicamente.</span></li>
                        </ul>
                    </div>
                    <div class="col-12 terms">
                        <strong>Para isso leia o termo abaixo e selecione os itens de confirmação ao final da página</strong>
                        <div class="textarea">
                            <textarea spellcheck="false" id="termos" readonly>
                                ESTOU CIENTE E AUTORIZO, neste ato que o(s) Banco(s) parceiro(s) tenha(m) acesso/consulte(m) os meus dados de depósitos e aplicações em outras instituições financeiras; as informações a meu respeito constantes no cadastro dos órgãos de proteção ao crédito tais como SPC e Serasa, bem como todas e quaisquer demais informações registradas no Sistema de Informações de Crédito do Banco Central (SCR), nos termos do artigo 1º, § 3º, V da Lei Complementar nº 105/01 segundo a qual não configura quebra de sigilo bancário a revelação de informações sigilosas com o expresso consentimento do interessado.
                                AUTORIZO expressamente a Instituição Financeira a divulgar, compartilhar e trocar informações a meu respeito com a IOUU Tecnologia e Serviços Financeiros LTDA - Epp ou qualquer outro terceiro a ela ligado ou relacionado, para fins de registro, análise de risco de crédito e qualquer outra finalidade, incluindo, mas não limitado a oferta de produtos da IOUU Tecnologia e Serviços Financeiros LTDA - Epp ou do respectivo terceiro.
                                DECLARO não ser ou ter como meus representantes, familiares ou outras pessoas de meu relacionamento próximo qualquer pessoa exposta politicamente (PEP) (pessoas que desempenhem ou desempenharam, nos últimos cinco anos, no Brasil ou no exterior, cargos, empregos e/ou funções públicas relevantes), conforme definição pela circular nº 3.461 de 24.07.2009 do Banco Central do Brasil.
                                DECLARO serem inteiramente verdadeiras as informações pessoais fornecidas à Instituição Financeira por meio de meu cadastro neste SITE e estar ciente de que estas informações condicionaram a avaliação da viabilidade do Empréstimo.</textarea>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="checkbox">
                            <div class="form-check d-flex">
                                <div class="checkboxContainer">
                                    <input type="checkbox" class="form-check-input" id="chkTermos" v-model="aceite">
                                    <span class="checkmark"></span>
                                </div>
                                <label for="form-check-label">Declaro que li e aceito os termos acima</label>
                            </div>
                            <div class="form-check d-flex">
                                <div class="checkboxContainer">
                                    <input type="checkbox" class="form-check-input" id="chkPolitica" v-model="acordos">
                                    <span class="checkmark"></span>
                                </div>
                                <label for="form-check-label"
                                >Declaro que estou de acordo com os 
                                <a :href="lpUrl+'/termos-de-uso-e-condicoes-para-empresa-tomadora/'" target="_blank">Termos de Uso</a> 
                                e com a <a :href="lpUrl+'/politica-de-privacidade/'" target="_blank">Politica de Privacidade</a></label>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div class="bt text-center">
                    <button class="btn btn-lg btn-primary" :disabled="!aceite || !acordos || !isValid() || !isValidMotivo() || !isValidGarantia() || !isValidGarantiaOutros() || redirectInvestment != 'social'" @click="onSubmit">Continuar</button>
                </div>
            </form>
        </div>
</template>

<script>
/* eslint-disable */
    import HubConsultaClient from '../../utils/hub-consulta-client'
    import ApiClient from '../../utils/api-client'
    import * as mutationTypes from '@/store/mutation-types.js'
    import Masker from '@/utils/masker'

    export default {
        metaInfo: {
            htmlAttrs: {
                lang: 'pt-br'
            },
            bodyAttrs: {
                class: 'solicita-emprestimo'
            }
        },
        props: {
            changeType: { type: Function },
        },
        data() {
            return {
                lpUrl:process.env.LP_URL,
                faturamento: '',
                value: '',
                prazo: '',
                motivo: '',
                phone: '',
                garantia: '',
                tipoPessoa: '',
                document: '',
                restricao: '',
                garantiaDetalhe: '',
                garantiaOutros: '',
                motivoDetalhe: '',
                aceite: false,
                acordos: false,
                type: this.$route.query.type,
                user: null,
                finishedLoading: false,
                hasLoan: null,
                prazos: [{
                        value: 6,
                        label: '6 meses'
                    },
                    {
                        value: 12,
                        label: '12 meses'
                    },
                    {
                        value: 24,
                        label: '24 meses'
                    },
                    {
                        value: 30,
                        label: '30 meses'
                    },
                    {
                        value: 36,
                        label: '36 meses'
                    }
                ],
                temGarantia: [{
                        value: 'sim',
                        label: 'Sim'
                    },
                    {
                        value: 'nao',
                        label: 'Não'
                    }
                ],
                temRestricao: [{
                        value: 'sim',
                        label: 'Sim'
                    },
                    {
                        value: 'nao',
                        label: 'Não'
                    }
                ],
                garantias: [{
                        value: 'Imóveis',
                        label: 'Imóveis'
                    },
                    {
                        value: 'Recebíveis',
                        label: 'Recebíveis'
                    },
                    {
                        value: 'Veículos',
                        label: 'Veículos'
                    },
                    {
                        value: 'Máquinas',
                        label: 'Máquinas'
                    },
                    {
                        value: 'Equipamentos',
                        label: 'Equipamentos'
                    },
                    {
                        value: 'Outros',
                        label: 'Outros'
                    }
                ],
                motivoEmp: [{
                        value: 'Expansão da empresa'
                    },
                    {
                        value: 'Capital de Giro'
                    },
                    {
                        value: 'Compra de estoque'
                    },
                    {
                        value: 'Refinanciamento de dívida'
                    },
                    {
                        value: 'Aquisição de máquinas e equipamentos'
                    },
                    {
                        value: 'Outros'
                    }
                ],
                tipo: [
                    {
                        value: "pessoa fisica"
                    },
                    {
                        value: "pessoa juridica"
                    }
                ]

            }
        },
        computed: {
            firstName: function () {
                if (this.user.name) {
                    return this.getFirstName(this.user.name);
                } else {
                    return this.getFirstName(this.user.username);
                }

            },
            name: function () {
                let n;

                if (this.user.name) {
                    n = this.user.name;
                } else {
                    n = this.user.username;
                }

                return n;
            },
            email: function () {
                return this.user.email;
            },
            redirectInvestment: function () {
                let newFormat = this.faturamento.split('.').join("")
                newFormat = parseFloat(newFormat.split(',').join("."))
                if(newFormat>360000){ 
                    return 'collective'
                }if(newFormat>25000){
                    return 'impact'
                }
                return 'social' 
            },
        },
        methods: {
            getFirstName(name) {
                let firstName = name.split(" ");

                return firstName[0];
            },
            isValid() {
                return this.name != '' && this.document != '' && this.motivo != '' && this.garantia != '' && this.restricao !=
                    '' && this.value != '' && this.faturamento != '';
            },
            isValidMotivo() {
                if (this.motivo === "Outros") {
                    return this.motivoDetalhe != '';
                } else {
                    return true;
                }
            },
            isValidGarantia() {
                if (this.garantia === "sim") {
                    return this.garantiaDetalhe != '';
                } else {
                    return true;
                }
            },
            isValidGarantiaOutros() {
                if(this.garantiaDetalhe === "Outros" && this.garantia === 'sim') {
                    return this.garantiaOutros != '';
                } else {
                    return true;
                }
            },
            validarCNPJ(cnpj) {
                cnpj = cnpj.replace(/[^\d]+/g, '');

                if (cnpj == '') return false;

                if (cnpj.length != 14)
                    return false;

                // Elimina CNPJs invalidos conhecidos
                if (cnpj == "00000000000000" ||
                    cnpj == "11111111111111" ||
                    cnpj == "22222222222222" ||
                    cnpj == "33333333333333" ||
                    cnpj == "44444444444444" ||
                    cnpj == "55555555555555" ||
                    cnpj == "66666666666666" ||
                    cnpj == "77777777777777" ||
                    cnpj == "88888888888888" ||
                    cnpj == "99999999999999")
                    return false;

                // Valida DVs
                let tamanho = cnpj.length - 2
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2)
                        pos = 9;
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(0))
                    return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2)
                        pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(1))
                    return false;

                return true;
            },
             validarCpf(strCPF) {
                var Soma;
                var Resto;
                Soma = 0;
                if (strCPF == "00000000000") return false;
                
                for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
                Resto = (Soma * 10) % 11;
                
                if ((Resto == 10) || (Resto == 11))  Resto = 0;
                if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
                
                Soma = 0;
                for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
                Resto = (Soma * 10) % 11;
                
                if ((Resto == 10) || (Resto == 11))  Resto = 0;
                if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
                return true;
            },
            verifyLastLoan(date) {
                let today = new Date();
                let timeStampToday = Math.round(today.getTime() / 1000);
                let h = today.getHours();
                let m = today.getMinutes();
                let s = today.getSeconds()
                let arrayDate = Masker.maskIsoDate(date).split('/')
                let objDate = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
                let timeStampDate = Math.round(objDate.getTime() / 1000);
                let hours = ((timeStampToday - timeStampDate) / 3600);
                let days = parseInt(hours / 24);
                let month = parseInt(days / 30);

                if (month >= 3) {
                    return true
                } else {
                    return false;
                }
            },
            formatReal(num) {
                let real;
                real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
                return real;
            },
            typeLoan(type) {
                let tipo;

                switch (type) {
                    case 'EMPPES':
                        tipo = 'emprestimo-pessoal';
                        break;

                    case 'EMPVEI':
                        tipo = 'emprestimo-veicular';
                        break;

                    case 'EMIMB':
                        tipo = 'emprestimo-imobiliario';
                        break;

                    case 'EMPIMP':
                        tipo = 'emprestimo-de-impacto';
                        break;


                    //Novo impacto - semelhante ao coletivo
                    case 'EMPIMP2':
                        tipo = 'emprestimo-de-impacto2';
                        break;

                    //Novo Social, semelhante ao impacto antigo
                    case 'EMPSOC':
                        tipo = 'emprestimo-social';
                        break;

                    default:
                        tipo = 'emprestimo-coletivo';
                        break;
                }

                return tipo;
            },
            onSubmit(e) {
                e.preventDefault()

                 this.$store.commit(mutationTypes.START_LOADING)
            console.log("1")
                if(this.tipoPessoa === "pessoa juridica") {
                    console.log("2")
                    if (!this.validarCNPJ(Masker.unmaskCnpj(this.document))) {
                        console.log("3")
                        this.$store.commit(mutationTypes.STOP_LOADING)
                    this.$Notify.error('CNPJ inválido! Por favor, digite um CNPJ válido.')
                    } else {
                        ApiClient.getLoansByDocuments(Masker.unmaskCnpj(this.document),this.typeLoan(this.type))
                            .then(response => {

                                console.log("4")
                                this.hasLoan = response;
                                if (this.hasLoan.data.length > 0) {
                                    let verify = this.verifyLastLoan(this.hasLoan.data[0].Created)
                                    console.log("5")
                                    if (!verify) {
                                        console.log("6")
                                        this.$store.commit(mutationTypes.STOP_LOADING)
                                        this.$Notify.error(
                                            'Esté CNPJ já possui uma solicitação anterior inferior a 3 meses');
                                    } else {
                                        console.log("7")
                                        this.postLoan();
                                    }
                                } else {
                                    console.log("8")
                                    this.postLoan();
                                }
                            })
                    }
                } else {

                    console.log("9")
                    if (!this.validarCpf(Masker.unmaskCpf(this.document))) {
                        console.log("10")
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        this.$Notify.error('Cpf inválido! Por favor, digite um Cpf válido.')
                    } else {
                        ApiClient.getLoansByDocuments(Masker.unmaskCnpj(this.document),this.typeLoan(this.type))
                            .then(response => {

                                console.log("11")
                                this.hasLoan = response;
                                if (this.hasLoan.data.length > 0) {
                                    console.log("12")
                                    let verify = this.verifyLastLoan(this.hasLoan.data[0].Created)
                                    if (!verify) {
                                        console.log("13")
                                        this.$store.commit(mutationTypes.STOP_LOADING)
                                        this.$Notify.error(
                                            'Esté Cpf já possui uma solicitação anterior inferior a 3 meses');
                                    } else {
                                        console.log("14")
                                        this.postLoan();
                                    }
                                } else {
                                    console.log("15")
                                    this.postLoan();
                                }
                        })
                     }
                }
            },
            postLoan() {
                let data = {
                    'Nome': this.name,
                    'TipoPessoa': this.tipoPessoa,
                    'Email': this.email,
                    'Documento': this.tipoPessoa === "pessoa juridica" ? Masker.unmaskCnpj(this.document) : Masker.unmaskCpf(this.document),
                    'Restricao': this.restricao,
                    'Garantia': this.garantia,
                    'TipoGarantia': this.garantiaDetalhe === 'Outros' ? this.garantiaOutros: this.garantiaDetalhe,
                    'Valor': this.formatReal(this.value),
                    'Prazo': parseInt(this.prazo),
                    'Motivo': this.motivo === "Outros"? this.motivoDetalhe: this.motivo,
                    'TipoEmprestimo': this.typeLoan(this.type),
                    'CodProduto': this.type,
                    'Faturamento': this.formatReal(this.faturamento),
                    'Celular': this.phone,
                    'Status': 'LIZA',
                }

                console.log("16")

                if(data.Valor <= 500 || data.Valor > 5000) {
                    console.log("17")
                    this.$store.commit(mutationTypes.STOP_LOADING)
                    this.$Notify.error('O valores devem ser superiores a R$ 500,00 e de no máximo R$ 5.000,00');
                } else {
                    HubConsultaClient.createLoans(data)
                    .then(response => {

                        console.log("18")
                        if(response.status !== 200) {
                            console.log("19")
                            this.$store.commit(mutationTypes.STOP_LOADING)
                            this.$Notify.error('Ocorreu um erro inesperado tente novamente!');
                        } else {

                            console.log("20")
                            if(this.typeLoan(this.type) == "emprestimo-social"){
                                this.$store.commit(mutationTypes.STOP_LOADING)
                                    this.$router.push(`/emprestimos/meus-emprestimos`);
                            }else{
                            console.log("21")
                            this.$store.commit(mutationTypes.STOP_LOADING)
                            this.$router.push(`/informacoes-adicionais/${this.typeLoan(this.type)}/${response.data.Msg}`);
                            }
                        }
                    })
                }                
            },
        },
        beforeCreate() {
            this.$store.commit(mutationTypes.START_LOADING)

            ApiClient.getUser()
                .then(response => {

                    console.log(response);
                    this.user = response;

                    this.finishedLoading = true;

                    this.$store.commit(mutationTypes.STOP_LOADING);
                })
                .catch(() => {
                    this.finishedLoading = true;
                    this.$store.commit(mutationTypes.STOP_LOADING);
                })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/iouu/mixins";
    @import "../../assets/styles/iouu/variables";

    h1 {
        font-family: $fontcontent;
        font-weight: 300;
        @include font-size(40px);
        padding-bottom: 20px;

        @include separador(150px, 5px, 40px, 20px, auto, auto, $c3); // MOBILE
        @include xs {
            margin-top: 110px;
            @include font-size(25px);
            @include separador(120px, 5px, 20px, 10px, auto, auto, $c3);
            strong {
                display: block;
            }
        } // DESKTOP
        @include ds {
            @include font-size(35px);
        }
    }

    .sub-title {
        margin-bottom: 40px;
        h2 {
            padding-bottom: 10px;
        }
        p {
            @include font-size(16px);
            color: #999;
        }

        @include xs {
            margin-bottom: 20px;
            h2 {
                @include font-size(22px);
            }
        }
    }

    h5 {
        margin-top: 20px;
        padding-bottom: 10px;
    }

    .form {
        label {
            @include font-size(11px);
            text-transform: uppercase;
            font-weight: bold;
            color: #999;
            margin-bottom: 0px;
            padding-bottom: 0px;
        }
        input {
            box-shadow: none;
        }
        select {
            margin-bottom: 0.75em;
        }

        @include xs {
            input,
            select {
                @include font-size(13px);
                height: 40px;
            }
            select {
                option {
                    padding: 0px;
                    line-height: 2px;
                    height: 10px !important;
                }
            }
        }
    }

    .textarea {
        background: #eee;
        padding: 20px 0 20px 20px;
        border-radius: 5px;

        textarea {
            @include font-size(12px);
            background: transparent;
            padding-right: 20px;
            height: 100px;
            border: none;
            border: none;
            box-shadow: none;
            resize: none;
        }
    }

    .terms {
        strong {
            display: block;
            color: red;
            padding-bottom: 10px;
        }
    }

    .checkbox {
        margin-top: 15px;
        label {
            @include font-size(13px);
            color: #666;
            font-weight: normal;
            display: block;
            margin: 0px;

            @include mob {
                font-size: calcRem(12);
                display: inline-block;
                vertical-align: middle;
                margin-top: 0;
                padding-bottom: 15px;
                width: calc(100% - 50px);
            }
        }

        .form-check {

            &{
                @include mob {
                    display: inline-block !important;
                    padding-left: 0;
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
            }

            .checkboxContainer {
                &{
                    @include mob {
                        display: inline-block;
                    }
                }
            }

            &:last-of-type {
                margin-top: 12px;
            }
        }
    }

    .bt {
        margin-top: 30px;
    }

    .btn-primary.disabled,
    .btn-primary:disabled {
        background-color: #ccc;
        border: none;
        cursor: default;
    }

    @include xs {
        .steps {
            .btn {
                display: block;
                width: 100%;
                padding-top: 10px;
                padding-bottom: 10px;
                &-primary {
                    font-size: 12px !important;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/loansForms/EmprestimoImpactoForm.vue